export default __webpack_public_path__ + "static/media/s3.6cf8df12.png";